import { ChangeDetectionStrategy, Component, Directive } from '@angular/core';
import {
  CDK_ROW_TEMPLATE,
  CdkFooterRow,
  CdkFooterRowDef,
  CdkHeaderRow,
  CdkHeaderRowDef,
  CdkRow,
  CdkRowDef,
} from '@angular/cdk/table';

// `columns` / `sticky` / `when` are inherited from CDK row defs as
// accessors; they need re-declaration in the metadata array so Angular
// re-aliases them to the `app*RowDef*` input names. `@Input` on an
// inherited accessor breaks the parent's getter/setter chain.

@Directive({
  selector: '[appHeaderRowDef]',
  providers: [
    { provide: CdkHeaderRowDef, useExisting: AppHeaderRowDefDirective },
  ],
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['columns: appHeaderRowDef', 'sticky: appHeaderRowDefSticky'],
})
export class AppHeaderRowDefDirective extends CdkHeaderRowDef {}

@Directive({
  selector: '[appFooterRowDef]',
  providers: [
    { provide: CdkFooterRowDef, useExisting: AppFooterRowDefDirective },
  ],
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['columns: appFooterRowDef', 'sticky: appFooterRowDefSticky'],
})
export class AppFooterRowDefDirective extends CdkFooterRowDef {}

@Directive({
  selector: '[appRowDef]',
  providers: [{ provide: CdkRowDef, useExisting: AppRowDefDirective }],
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['columns: appRowDefColumns', 'when: appRowDefWhen'],
})
export class AppRowDefDirective<T> extends CdkRowDef<T> {}

@Component({
  selector: 'app-header-row, tr[app-header-row]',
  template: CDK_ROW_TEMPLATE,
  host: {
    class: 'app-header-row',
    role: 'row',
  },
  exportAs: 'appHeaderRow',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class AppHeaderRowComponent extends CdkHeaderRow {}

@Component({
  selector: 'app-footer-row, tr[app-footer-row]',
  template: CDK_ROW_TEMPLATE,
  host: {
    class: 'app-footer-row',
    role: 'row',
  },
  exportAs: 'appFooterRow',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class AppFooterRowComponent extends CdkFooterRow {}

@Component({
  selector: 'app-row, tr[app-row]',
  template: CDK_ROW_TEMPLATE,
  host: {
    class: 'app-row',
    role: 'row',
  },
  exportAs: 'appRow',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class AppRowComponent extends CdkRow {}
